import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarToday = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "today",
	"data-name": "today",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			className: "plan2plate-icon",
			x: 1.48,
			y: 3.3699999,
			width: 21.040001,
			height: 4.7800002,
			id: "rect1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "plan2plate-icon",
			x: 1.48,
			y: 8.1499996,
			width: 21.040001,
			height: 14.35,
			id: "rect2"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 6.2600002,
			y1: .5,
			x2: 6.2600002,
			y2: 5.2800002,
			id: "line10"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12,
			y1: .5,
			x2: 12,
			y2: 5.2800002,
			id: "line11"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 17.74,
			y1: .5,
			x2: 17.74,
			y2: 5.2800002,
			id: "line12"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon round-linecap",
			id: "path12",
			cx: 12,
			cy: 14.746126,
			r: 3.3979521
		})
	]
});
const ForwardRef = forwardRef(SvgCalendarToday);
export default ForwardRef;
